// Seeded from real student data (grouped + de-duplicated for casing/whitespace
// variants, e.g. "USIL" vs "Universidad San Ignacio de Loyola"). Most common
// entries first, then the rest alphabetical, "Other" always last.
//
// Shared by the profile Details form and the experience booking modal — add
// new schools here only.

export const HOME_UNIVERSITIES = [
  // most common
  "NEOMA Business School",
  "Maastricht University",
  "Sciences Po Lyon",
  "University of Groningen",
  // alphabetical
  "EDHEC Business School",
  "EMLYON",
  "Erasmus University Rotterdam",
  "Hanze University of Applied Sciences",
  "Hochschule Stralsund",
  "HZ University of Applied Sciences",
  "IAE Angers",
  "INSA Toulouse",
  "IPSA",
  "King's College London",
  "Newcastle University",
  "Pforzheim University",
  "Université Toulouse Capitole",
  "University of Angers",
  "University of Applied Sciences BFI Vienna",
  "University of Exeter",
  "University of Innsbruck",
  "University of Wuppertal",
  "Other",
];

export const ABROAD_UNIVERSITIES = [
  // most common
  "Universidad del Pacífico",
  "PUCP",
  "USIL",
  "ESAN",
  // alphabetical
  "UPC",
  "Universidad de Lima",
  "Universidad de Piura",
  "UTEC",
  "Other",
];

/**
 * A student's existing free-text value (entered before this was a dropdown)
 * may not match a seeded option exactly — different casing/whitespace, or a
 * school not in the list at all. Case/whitespace-insensitive match; anything
 * that still doesn't match starts in "other" mode so their original text is
 * preserved in the free-text box instead of silently discarded.
 */
export const modeForValue = (
  value: string,
  list: string[],
): "select" | "other" => {
  if (!value) return "select";
  const normalized = value.trim().toLowerCase();
  return list.some((opt) => opt.toLowerCase() === normalized)
    ? "select"
    : "other";
};